import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer';
import { GlassSelect } from '../common/GlassSelect';

export const VersionSelectorRight = ({ passive, viewportMode, deniedServices, versions, currentValue, onEditMode, handleVersionChange }) => {
    const isComparativeMode = viewportMode === 'comparative';
    const isEditionDenied = deniedServices.includes('showEdition');
    const isNotPassive = !passive;

    const options = versions
        .filter(option => !(isComparativeMode && option.value === -1))
        .flatMap(option => {
            const isComparativeEmptyValue = isComparativeMode && option.value === '';
            return isComparativeEmptyValue
                ? [{ value: -3, disabled: false, label: 'Setup' }]
                : [option];
        });

    return (
        <div id="versionSelectorRight" className={`vh-select-group versionSelectorRight hide-mobile ${isEditionDenied ? 'hidden' : '' } ${isComparativeMode ? 'comparative' : ''}`}>
            {isNotPassive && (
                <>
                    <label id='versionSelectorLabelRight'>{ihm_viewer__dictionary.VERSION_MODE[locale()]}</label>
                    <GlassSelect
                        id="versionSelectorRight"
                        options={options}
                        value={currentValue}
                        onChange={handleVersionChange}
                        disabled={onEditMode}
                    />
                </>
            )}
        </div>
    );
};
